// CommonJS
// var $ = require('../lib/jquery/dist/jquery.min')
// console.log($);